import { render, staticRenderFns } from "./TemplateClientXslt.vue?vue&type=template&id=907af21e&scoped=true"
import script from "./TemplateClientXslt.vue?vue&type=script&lang=js"
export * from "./TemplateClientXslt.vue?vue&type=script&lang=js"
import style0 from "./TemplateClientXslt.vue?vue&type=style&index=0&id=907af21e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "907af21e",
  null
  
)

export default component.exports